module.exports = __webpack_public_path__ + "assets/media/announcer_ment_training_1.3faf3f40.mp3";